import runes from 'runes';
export const capitalizeFirstLetter = (text?: string): string => {
    if (!text) {
        return '';
    }
    return text.charAt(0).toUpperCase() + text.slice(1).toLocaleLowerCase();
};

export const getFirstLetter = (string: string, num = 1) => {
    if (typeof string === 'undefined' || string === null) {
        return '';
    }
    const strArr = runes(string);
    return strArr.length > 0 ? strArr.slice(0, num).join('') : '';
};

export const urlRegex =
    /^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
export const urlRegexOrEmpty =
    /^$|^(https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

export const usernameRegex = /^([0-9a-zA-Z_\-])+$/;
export const usernameForLinkRegex = /^([0-9a-zA-Z_.\-])+$/;
export const phoneRegex = /^([0-9 +\(\)])+$/;

export const listSocialWithUsername = ['INSTAGRAM', 'TWITTER'];

export const getUsernameFromUrl = (url: string, social: string) => {
    if (listSocialWithUsername.includes(social)) {
        if (url) {
            const arrStr = url.split('/');
            return arrStr[arrStr.length - 1];
        }
        return '';
    }
    return url;
};

export const generateUrlFromUserName = (url: string, social: string) => {
    if (url.match(urlRegex)) return url;

    if (social === 'INSTAGRAM') {
        return `https://www.instagram.com/${url}`;
    }
    if (social === 'TWITTER') {
        return `https://twitter.com/${url}`;
    }
    return url;
};

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const formatFileSize = (bytes: number, si = false, dp = 1) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
};
